<h2 mat-dialog-title>{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TITULO' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <mat-horizontal-stepper [(selectedIndex)]="pasoErrores" #stepper>
    <mat-step>
      <h3>
        <span *ngIf="numeroErrores <= 100">{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TOTAL_ERRORES_1' | translate}}: <b>{{numeroErrores}}</b> </span>
        <span *ngIf="numeroErrores > 100" [innerHTML]="'CERTIFICAR.COLABORADORES.MODAL_ERROR.TOTAL_ERRORES_2' | translate"></span>
      </h3>
      <p>{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.INFO_1' | translate}}</p>
      <p><em [innerHTML]="'CERTIFICAR.COLABORADORES.MODAL_ERROR.INFO_2' | translate"></em></p>

      <table mat-table [dataSource]="datosErrores" class="mat-elevation-z8 w100">
        <ng-container matColumnDef="tipoError">
          <th mat-header-cell *matHeaderCellDef>{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_RESUMEN.TIPO' | translate}}</th>
          <td mat-cell *matCellDef="let element"> {{'CERTIFICAR.COLABORADORES.CARD_ERRLIST.ERRORES.' + element.tipo | translate}} </td>
        </ng-container>

        <ng-container matColumnDef="totalErrores">
          <th mat-header-cell *matHeaderCellDef class="lftBrd">{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_RESUMEN.TOTAL' | translate}}</th>
          <td mat-cell *matCellDef="let element" class="lftBrd" align="center">
            <h3><b>{{element.total}}</b></h3>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef class="lftBrd">{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_RESUMEN.ACCIONES' | translate}}</th>
          <td mat-cell *matCellDef="let element" class="lftBrd" align="center">
            <button mat-icon-button color="primary" matTooltip="{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_RESUMEN.MASINFO' | translate}}" class="m-5" (click)="infoError(element.tipo)">
              <mat-icon class="s-30">info</mat-icon>
            </button>
            <button *ngIf="element.tipo != 'noCeo'" mat-icon-button color="accent" matTooltip="{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_RESUMEN.VERMAS' | translate}}" class="m-5" (click)="verListaErrores(element.lista)">
              <mat-icon class="s-30">search</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </mat-step>
    <mat-step>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <h3>{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_LISTA.TOTAL_1' | translate}}: <b>{{listaEspecifica.length}}</b></h3>
        <h3 *ngIf="listaExcedente">{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_LISTA.TOTAL_2' | translate}}: <b>{{totalExcedentes}}</b></h3>
      </div>
      <h3 *ngIf="listaExcedente"><em>{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_LISTA.INFO' | translate}}</em></h3>
      <table mat-table [dataSource]="listaEspecifica" class="mat-elevation-z8 w100">
        <ng-container matColumnDef="fila">
          <th mat-header-cell *matHeaderCellDef>{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_LISTA.FILA' | translate}}</th>
          <td mat-cell *matCellDef="let element" align="center">
            <h3>{{element.fila}}</h3>
          </td>
        </ng-container>

        <ng-container matColumnDef="columna">
          <th mat-header-cell *matHeaderCellDef class="lftBrd">{{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_LISTA.COLUMNA' | translate}}</th>
          <td mat-cell *matCellDef="let element" class="lftBrd" align="center">
            <h3>{{element.columna}}</h3>
          </td>
        </ng-container>

        <ng-container matColumnDef="dato">
          <th mat-header-cell *matHeaderCellDef class="lftBrd" align="center" width="75%">
            <span *ngIf="!headerSecEsp">
              {{'CERTIFICAR.COLABORADORES.MODAL_ERROR.TABLA_LISTA.DATO' | translate}}
            </span>
            <span *ngIf="headerSecEsp">
              {{'CERTIFICARV3.ETI_KEY_NO_EMPL' | translate}}
            </span>
          </th>
          <td mat-cell *matCellDef="let element" class="lftBrd" align="center" width="75%">
            <blockquote><code>{{element.dato}}</code></blockquote>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnasListaEspecifica"></tr>
        <tr mat-row *matRowDef="let row; columns: columnasListaEspecifica;"></tr>
      </table>
    </mat-step>
  </mat-horizontal-stepper>


</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="accent" class="mt-20 mr-20" *ngIf="pasoErrores == 1" (click)="pasoErrores = 0">
    {{'CERTIFICAR.COLABORADORES.MODAL_ERROR.BOTONES.REGRESAR' | translate}}
    <mat-icon class="ml-20">arrow_back</mat-icon>
  </button>
  <button mat-raised-button color="primary" class="mt-20 dialog_confirmar" (click)="salir()">
    {{'CERTIFICAR.COLABORADORES.MODAL_ERROR.BOTONES.CONTINUAR' | translate}}
    <mat-icon class="ml-20">check</mat-icon>
  </button>
</div>
